import * as Types from '../constants/Types';

export const getListBaggages = (filters) => ({ type: Types.BAGGAGE_LIST_ACTION, filters });
export const getAllBaggages = (filters) => ({ type: Types.BAGGAGE_ALL_LIST_ACTION, filters });
export const setListBaggages = (baggages) => ({ type: Types.BAGGAGE_LIST_SUCCESS, baggages});

export const getBaggageDetail = (id) => ({ type: Types.BAGGAGE_DETAIL_ACTION, id });
export const setBaggageDetail = (baggage) => ({ type: Types.BAGGAGE_DETAIL_SUCCESS, baggage });
export const updateBaggageDetail = (baggage) => ({ type: Types.BAGGAGE_DETAIL_UPDATE_ACTION, baggage });
export const createBaggageDetail = (baggage) => ({ type: Types.BAGGAGE_DETAIL_CREATE_ACTION, baggage });
export const deleteBaggageDetail = (baggage, filters) => ({ type: Types.BAGGAGE_DETAIL_DELETE_ACTION, baggage, filters });


